import React from 'react';
import styles from './styles.module.scss';

import {
  IoIosArrowDropleft as FaArrowCircleLeft,
  IoIosArrowDropright as FaArrowCircleRight,
} from 'react-icons/io';

export function Pagination({
  color,
  linesPerPageFilters,
  linesPerPageOptions,
  filterPageSelectors,
  totalPages,
  filtersSelectedValues,

  onLinesPerPageChange = null,
  onPagePreviousChange = null,
  onPageNextChange = null,
  onInputPageChange = null,
  onKeyPressChange = null,
}) {

  function handleLinesPerPageChange({ currentTarget }) {
    if (onLinesPerPageChange) {
      const newValue = currentTarget.value;
      onLinesPerPageChange(newValue);
    }
  }

  function handlePagePreviousChange({ currentTarget }) {
    if (onPagePreviousChange) {
      const newValue = currentTarget.value;
      onPagePreviousChange(newValue);
    }
  }
  function handlePageNextChange({ currentTarget }) {
    if (onPageNextChange) {
      const newValue = currentTarget.value;
      onPageNextChange(newValue);
    }
  }

  function handleInputPageChange({ currentTarget }) {
    if (onInputPageChange) {
      const newValue = currentTarget.value;
      onInputPageChange(parseInt(newValue));
    }
  }
  function handleOnKeyPressChange(event) {
    if (onKeyPressChange) {
      const newValue = event.key;
      onKeyPressChange(newValue);
    }
  }

  return (
    <div className={styles.big_container_pagination}>
      {/* LINHAS POR PG */}
      <div className={styles.linesPerPage}>
        <label htmlFor="input-qtdPage">Linhas por página: </label>
        <select
          style={{ color: `${color}` }}
          value={linesPerPageFilters}
          onChange={handleLinesPerPageChange}
        >
          {linesPerPageOptions.map((olp) => (
            <option value={olp}>{olp}</option>
          ))}
        </select>
      </div>

      {/* SELETOR */}
      <div className={styles.selector}>
        <FaArrowCircleLeft
          color={filterPageSelectors === 0 ? '#b4b3b6' : `${color}`}
          onClick={handlePagePreviousChange}
          size={24}
        />
        <FaArrowCircleRight
          color={
            totalPages === 0 || filterPageSelectors === totalPages - 1
              ? '#b4b3b6'
              : `${color}`
          }
          onClick={handlePageNextChange}
          size={24}
        />
      </div>

      {/* PG ATUAL */}
      <div className={styles.page_atual}>
        <input
          value={filtersSelectedValues ?? '1'}
          type="number"
          className="input-page"
          style={{ color: `${color}` }}
          onChange={handleInputPageChange}
          onKeyPress={handleOnKeyPressChange}
        />
        <text>de {totalPages}</text>
      </div>
    </div>
  );
}
